import multiApiClient from "./base";

export const plentyCredentialsApi = {
  // Credentials management
  getCredentials: () => {
    return multiApiClient.get("/plenty/credentials/");
  },

  createCredential: (data) => {
    return multiApiClient.post("/plenty/credentials/", data);
  },

  deleteCredential: (credentialId) => {
    return multiApiClient.delete(`/plenty/credentials/${credentialId}`);
  },

  updateCredential: (credentialId, data) => {
    return multiApiClient.put(`/plenty/credentials/${credentialId}`, data);
  },

  toggleActiveCredential: (credentialId) => {
    return multiApiClient.post(
      `/plenty/credentials/${credentialId}/toggle-active`,
    );
  },

  testCredential: (data) => {
    return multiApiClient.post(`/plenty/credentials/test`, data);
  },
};
